import { SurveyLaunchForm } from '../types/survey-launch-form.types';

/** All-neutral values — no mock/feature-specific data. */
export const DEFAULT_SURVEY_LAUNCH_FORM: SurveyLaunchForm = {
  surveyUrls: {
    sameSettingsForAllSurveys: false,
    liveUrl: '',
    testUrl: '',
    disableAutomaticVariableMapping: false,
  },
  uniqueLinks: {
    sameSettingsForAllSurveys: false,
    uniqueLinksEnabled: false,
    entryLinks: [],
  },
  billingDetails: {
    sameSettingsForAllSurveys: false,
    billingId: '',
    pmEmailsInvoice: '',
    billingClient: '',
  },
  ai: {
    aidaEnabled: false,
  },
  dataQuality: {
    sameSettingsForAllSurveys: false,
    pureScoreFilterEnabled: false,
    dataQualityBatteryEnabled: false,
  },
  launchFeatures: {
    sameSettingsForAllSurveys: false,
    marginMaxEnabled: false,
    basicTokenEnabled: false,
    basicToken: { value: '' },
    modularLaunchEnabled: false,
    supplierAllocationThrottleEnabled: false,
    bypassLoiThresholdEnabled: false,
    scheduledLaunchEnabled: false,
    scheduledLaunch: { date: null, hour: '', minute: '', timezone: '' },
    scheduledPauseEnabled: false,
    scheduledPause: {
      days: [],
      time: '',
      timezone: '',
      duration: { days: null, hours: null, minutes: null },
    },
    softLaunchEnabled: false,
    softLaunch: { completes: null, percentile: null },
  },
  quotaFeatures: {
    sameSettingsForAllSurveys: false,
    quotaThrottlingEnabled: false,
    feotEnabled: false,
    feot: { customPacing: false, pacingUnit: 'hours', pacingInterval: null },
    qbpEnabled: false,
    selectedQbpQuota: '',
  },
  filterAudience: {
    sameSettingsForAllSurveys: false,
    includeExcludeRespondentsEnabled: false,
    dateRange: null,
    surveyGrouping: '',
    exclusionPeriodDays: null,
    permanentExclusionEnabled: false,
    selectedRespondentStatuses: [],
    externalSurveyId: '',
  },
  communication: {
    sameSettingsForAllSurveys: false,
    buyerProjectManager: null,
    operatorProjectManager: null,
    subscriberEmails: '',
    messageToSuppliers: '',
    crmId: '',
    asanaId: '',
  },
};
